import { createSelector } from 'reselect';
import { createScopedSelector } from '@mews/framework';
import modulesSelector from '../../selector';

export const MODULE_NAME = 'rebate';

const parentModuleSelector = createSelector(modulesSelector, (state) => state[MODULE_NAME]);
export const scopedModuleSelector = createScopedSelector({ parentSelector: parentModuleSelector });
